import { render, staticRenderFns } from "./CreateUpdateConnection.vue?vue&type=template&id=737cfb6c&lang=pug&"
import script from "./CreateUpdateConnection.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports